import * as React from 'react';

import { DatosApoderado } from '../tipos';
import Campo from './Campo';
import Info from './Info';
import InformacionPersonal from './InformacionPersonal';

type InformacionApoderadoProps = DatosApoderado;
const InformacionPersonalApoderado: React.FunctionComponent<InformacionApoderadoProps> = props => {
    if (!props.relacionConAlumno) {
        return <Info titulo='Información de apoderado'>El alumno es su propio apoderado</Info>;
    }
    return (
        <div>
            <InformacionPersonal titulo='Información apoderado' {...props} />
            <Campo etiqueta='Relación con alumno' valor={props.relacionConAlumno} />
        </div>
    );
};

export default InformacionPersonalApoderado;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/InformacionPersonalApoderado.tsx